module.exports = __webpack_public_path__ + "static/media/29BDOS25.abead438.jpg";